export const addTLGroupTerminalLinksTheme = {
  header: {
    bg: 'palette.surface.4',
    boxShadow: 'palette.black:0.06',
  },
};
